import { TooltipWrapper } from 'components/TooltipWrapper';
import type { RadioPropOnChange } from 'uikit';
import { Radio } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';
import { useCallback, useMemo } from 'react';

export interface IAgRadioCellRendererComponent extends ICellRendererParams {
    message?: string;
    isDisabled?: boolean;
    idKey?: string;
    checkedId?: number;
    onCheckChange: (id: number, checked: boolean) => void;
}

const style = { display: 'flex', alignItems: 'center', height: '100%' };

export const AgRadioCellRendererComponent: React.FC<IAgRadioCellRendererComponent> = (props) => {
    const { message, isDisabled, onCheckChange, idKey = 'id', checkedId, data } = props;

    const id = useMemo(() => data?.[idKey], [data, idKey]);

    const isChecked = useMemo(() => !!checkedId && id === checkedId, [checkedId, id]);

    const onChange: RadioPropOnChange = useCallback(
        ({ checked }) => {
            onCheckChange(id, checked);
        },
        [id, onCheckChange],
    );

    return (
        <TooltipWrapper direction="upCenter" message={message} isHidden={!message} style={style}>
            <Radio view="ghost" checked={isChecked} onChange={onChange} disabled={isDisabled} />
        </TooltipWrapper>
    );
};

AgRadioCellRendererComponent.displayName = 'AgRadioCellRendererComponent';
